module.exports = __webpack_public_path__ + "static/original-mattress-4-0c51b2a733867412839cbff71f7b66e5.png";